var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.3529C22 11.8811 20.393 9.78024 18.1551 9.01498C17.8371 6.19371 15.4159 4 12.4762 4C9.32028 4 6.7619 6.52827 6.7619 9.64706C6.7619 10.3369 6.88706 10.9978 7.11616 11.6089C6.8475 11.5567 6.56983 11.5294 6.28571 11.5294C3.91878 11.5294 2 13.4256 2 15.7647C2 18.1038 3.91878 20 6.28571 20H16.2857C19.4416 20 22 17.4717 22 14.3529ZM12.353 11.9428C12.6608 12.22 12.6855 12.6942 12.4083 13.002L11.0571 14.502C10.9194 14.6548 10.725 14.7444 10.5194 14.7497C10.3137 14.7551 10.1149 14.6758 9.96947 14.5303L8.46964 13.0303C8.17676 12.7374 8.17679 12.2625 8.4697 11.9696C8.76261 11.6768 9.23748 11.6768 9.53036 11.9697L9.70015 12.1395C10.0888 10.4829 11.5753 9.25 13.3511 9.25C15.423 9.25 17.1011 10.9284 17.1011 13C17.1011 15.0716 15.423 16.75 13.3511 16.75C12.9369 16.75 12.6011 16.4142 12.6011 16C12.6011 15.5858 12.9369 15.25 13.3511 15.25C14.5946 15.25 15.6011 14.2433 15.6011 13C15.6011 11.7567 14.5946 10.75 13.3511 10.75C12.4997 10.75 11.7595 11.2219 11.3772 11.9185C11.659 11.6883 12.0743 11.6917 12.353 11.9428Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSync);
export default __webpack_public_path__ + "static/media/cloud-sync.fa7f1685a946a70051768b71d701ec0d.svg";
export { ForwardRef as ReactComponent };